import React, { useState, useEffect } from 'react';

// Components
import { Image, Transformer } from 'react-konva';

const TransformableImage = ({
  frameOne,
  selectedFrame,
  shapeProps,
  isSelected,
  onSelect,
  onChange,
  imageWidth,
  imageHeight,
  image,
  onMouseDown,
  onTouchStart,
}) => {
  const [xaxis, setXaxis] = useState(100)
  const [yaxis, setYaxis] = useState(30)
  const [xAxisWidth, setXAxisWidth] = useState(150)
  const [groupHeight, setGroupHeight] = useState(130)
  const shapeRef = React.useRef();
  const trRef = React.useRef();
  const groupDimensions = {
    height: 70,
    width: 60,
  };
  const aspectRatio = 1.5;
  const [imageRenderWidth, setImageRenderWidth] = useState(60);
  const [imageRenderHeight, setImageRenderHeight] = useState(60);

  React.useEffect(() => {
    if (isSelected) {
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  // useEffect(() => {
  //   if (selectedFrame === frameOne) {
  //     setXaxis(180)
  //     setYaxis(170)
  //     setXAxisWidth(165)
  //     setImageRenderHeight(60)

  //   } else {
  //     setXaxis(120)
  //     setYaxis(50)
  //     setXAxisWidth(150)
  //     setImageRenderHeight(60)
  //   }
  // }, [selectedFrame])

  return (
    <div style={{ background: '#fff' }}>
      <Image

        image={image}
        width={imageRenderWidth}
        x={xaxis}
        y={yaxis}
        height={imageRenderHeight}
        // onClick={onSelect}
        // onTap={onSelect}
        onMouseDown={onMouseDown}
        onTouchStart={onTouchStart}
        ref={shapeRef}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...shapeProps}
        // draggable
        onDragEnd={(e) => {
          onChange({
            ...shapeProps,
            x: e.target.x(),
            y: e.target.y(),
          });
        }}
        onTransformEnd={() => {
          if (shapeRef.current) {
            const node = shapeRef.current;
            onChange({
              ...shapeProps,
              x: node.x(),
              y: node.y(),
            });
          }
        }}
      />
      {isSelected && (
        <Transformer
          ref={trRef}
          boundBoxFunc={(oldBox, newBox) => {
            if (newBox.width < 5 || newBox.height < 5) {
              return oldBox;
            }
            return newBox;
          }}
        />
      )}
    </div>
  );
};

export default TransformableImage;
